module.exports = __webpack_public_path__ + "media/application/images/icons/login-7d31da5f4621358d7b3f5978d57d3414.svg";